/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** The type of the point history entry */
export type PointHistoryEntryType = 'EARNED' | 'PENDING' | 'REDEEMED' | 'REMOVED';

/** The source of the points issuance */
export type PointIssuanceSource =
  | 'BONUS_POINTS'
  | 'CUSTOMER_SUPPORT'
  | 'MULTIPLE_SOURCES'
  | 'OFFER_COMPLETION'
  | 'ORDER'
  | 'SWEETGREEN'
  | 'VOIDED_ORDER';

export type LoyaltyPointHistoryQueryVariables = Exact<{
  page: number;
  take: number;
}>;

export type LoyaltyPointHistoryQuery = {
  readonly pointHistoryForUser:
    | { readonly message: string; readonly status: number }
    | {
        readonly pointHistoryEntries: ReadonlyArray<{
          readonly __typename: 'PointHistoryEntry';
          readonly id: string;
          readonly date: string;
          readonly type: Types.PointHistoryEntryType | null;
          readonly value: number;
          readonly source: Types.PointIssuanceSource | null;
        } | null>;
        readonly pointExpirationEntries: ReadonlyArray<{
          readonly __typename: 'PointExpirationEntry';
          readonly id: number;
          readonly amountExpiring: number;
          readonly numOfDaysUntilExpiration: number;
        }>;
        readonly pagination: {
          readonly page: number;
          readonly take: number;
          readonly total: number;
          readonly last: number;
        };
      };
};

export const LoyaltyPointHistoryDocument = gql`
  query LoyaltyPointHistory($page: Int!, $take: Int!) {
    pointHistoryForUser(page: $page, take: $take) {
      ... on PointHistoryForUserSuccess {
        pointHistoryEntries {
          id
          __typename
          date
          type
          value
          source
        }
        pointExpirationEntries {
          id
          __typename
          amountExpiring
          numOfDaysUntilExpiration
        }
        pagination {
          page
          take
          total
          last
        }
      }
      ... on PointHistoryForUserError {
        message
        status
      }
    }
  }
`;

export function useLoyaltyPointHistoryQuery(
  options: Omit<Urql.UseQueryArgs<LoyaltyPointHistoryQueryVariables>, 'query'>,
) {
  return Urql.useQuery<LoyaltyPointHistoryQuery, LoyaltyPointHistoryQueryVariables>({
    query: LoyaltyPointHistoryDocument,
    ...options,
  });
}
